import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function ImpactWaterMonitoring() {
  return (
    <div className="art-page">
      <SEO
        title="Gold Standard PoA Monitoring — Impact Water"
        description="CIRCODU has conducted Gold Standard PoA monitoring for Impact Water across two separate engagements."
        keywords="gold standard, poa monitoring, impact water, improved stoves, traditional stoves, emissions testing, biomass combustion, climate impacts, ISO 19867-1, institutional cooking, electric cooking, Uganda, carbon finance, emissions reduction, sustainable energy, cookstove monitoring, carbon project development, independent monitoring organization, carbon credit verification, CIRCODU, Gold Standard monitoring Uganda, Impact Water Uganda, improved stoves monitoring Uganda, traditional stoves testing Uganda, emissions testing Uganda, biomass combustion monitoring Uganda, ISO 19867-1 testing Uganda, institutional cooking monitoring Uganda, electric cooking monitoring Uganda"
        url="/Gold-Standard-PoA-Monitoring-Impact-Water"
        datePublished="2025-05-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Gold Standard PoA Monitoring — Impact Water
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              May 01, 2025
            </div>
            <h1 className="art-title">
              Gold Standard PoA Monitoring — Impact Water
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                CIRCODU has conducted{" "}
                <strong>Gold Standard PoA monitoring for Impact Water</strong>{" "}
                across two separate engagements, supporting the verification of
                improved stove performance within Impact Water's Uganda
                programme portfolio.
              </p>
              <h2 className="art-subheading">Monitoring Engagements</h2>
              <ol>
                <li>
                  <strong>March–May 2023:</strong> CIRCODU verified the
                  performance of <strong>55 improved stoves</strong> under
                  Impact Water's PoA, conducting assessments in line with Gold
                  Standard monitoring requirements.
                </li>
                <li>
                  <strong>May 2025:</strong> In a second engagement, CIRCODU
                  performed <strong>ISO 19867-1 protocol testing</strong> using
                  nine traditional charcoal stoves as part of Impact Water's{" "}
                  <strong>Uganda Schools Electricity Upgrades</strong> programme
                  — supporting the baseline characterisation needed to quantify
                  the transition from charcoal to electric cooking in
                  institutional settings.
                </li>
              </ol>
              <p>
                The 2025 engagement is particularly notable for its
                forward-looking nature: by establishing a rigorous combustion
                baseline for traditional charcoal stoves in schools, CIRCODU's
                testing provides the counterfactual data that will enable
                accurate measurement of emissions reductions as schools
                transition to electric cooking — an increasingly important
                methodology as Uganda's institutional eCooking movement
                accelerates.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's PoA monitoring and
                laboratory testing services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
